import { render, staticRenderFns } from "./Payment-Empowerment.vue?vue&type=template&id=1a34ccca&scoped=true&"
import script from "./Payment-Empowerment.vue?vue&type=script&lang=js&"
export * from "./Payment-Empowerment.vue?vue&type=script&lang=js&"
import style0 from "./Payment-Empowerment.vue?vue&type=style&index=0&id=1a34ccca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a34ccca",
  null
  
)

export default component.exports